import { createContext, useContext } from "react";

// App.js keeps a hidden (display:none), fully-live copy of <Tournament>
// mounted in the background whenever the "Screen size" preview iframe is
// showing instead (see App.js's dualMountActive) - that avoids a real
// unmount/remount (full refetch, lost scroll/tab state) on every toggle.
// display:none only hides normal DOM content though - BottomSheetPanel.jsx
// (and anything else portal'd straight to document.body) renders OUTSIDE
// that hidden subtree entirely, so it stayed visibly floating over the
// screen even while its own parent tree was hidden. Components that portal
// to document.body should check this context and render nothing while true.
const PreviewHiddenContext = createContext(false);

export const PreviewHiddenProvider = PreviewHiddenContext.Provider;

export const useIsHiddenForPreview = () => useContext(PreviewHiddenContext);
